import ErrorHandler from '@foundryspatial/buefy-error-handler';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import Buefy from 'buefy';
import numeral from 'numeral';
import Vue from 'vue';
import numFormat from 'vue-filter-number-format';
import VueScrollMonitor from 'vue-scrollmonitor';

import Api from '@/api.js';
import App from '@/App.vue';
import shortenLargeNumber from '@/filters/shortenLargeNumber.js';
import uuid from '@/plugins/UUID.js';
import router from '@/router.js';
import { autoFormatNumber } from '@/utilities/numUtils.js';

Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })],
});

Vue.use(Buefy);

Vue.use(VueScrollMonitor);

Vue.use(ErrorHandler, {
    // send critical errors to Sentry.io after displaying the notification
    afterNotification(error, message, critical) {
        if (critical && error instanceof Error) {
            Sentry.captureException(error);
        }
    },
});

Vue.use(Api);

Vue.use(uuid);

Vue.config.productionTip = false;

// number formatting filters
Vue.filter('numFormat', numFormat(numeral));
Vue.filter('numAutoFormat', autoFormatNumber);
Vue.filter('shortenLargeNum', shortenLargeNumber(numeral));

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
